<template>
  <div class="flex flex-col">
    <div class="image" v-loading="loading">
      <img
        ref="imgRef"
        @load="onImageLoad"
        crossorigin="anonymous"
        class="cropperImage"
        :src="src"
      />
    </div>
    <div class="h-4"></div>
    <div class="flex flex-row items-center gap-2 justify-between">
      <div class="flex items-center gap-2 my-4">
        <el-tooltip content="set image aspect ratio" placement="top">
          <label class="flex items-center" for="aspectRatioInput">
            <i class="el-icon-s-operation" style="font-size:20px;"></i>
          </label>
        </el-tooltip>
        <el-input
          id="aspectRatioInput"
          type="text"
          v-model="aspectRatioInput"
          placeholder="1/1"
          textAlign="center"
          @change="onAspectRatioChange"
        />
      </div>
      <el-tooltip content="reset" placement="top">
        <el-button @click="onReset">
          <i class="el-icon-refresh" style="font-size:20px;"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip content="rotate 90deg" placement="top">
        <el-button @click="onRotateLeft">
          <i class="el-icon-refresh-left" style="font-size:20px;"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip content="rotate -90deg" placement="top">
        <el-button @click="onRotateRight">
          <i class="el-icon-refresh-right" style="font-size:20px;"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip content="cancel" placement="top">
        <el-button @click="onCancel">
          <i class="el-icon-close" style="font-size:20px;"></i>
        </el-button>
      </el-tooltip>
      <el-tooltip content="confirm" placement="top">
        <el-button @click="onConfirm">
          <i class="el-icon-check" style="font-size:20px;"></i>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  name: "ImageCropperView",
  props: {
    file: {
      type: [String, File],
      default: null,
    },
    aspectRatio: {
      type: String,
      default: "1/1",
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      aspectRatioInput: this.aspectRatio || "1/1",
      cropper: null,
      loading: false,
    };
  },
  computed: {
    src() {
      if (this.file instanceof File) {
        return URL.createObjectURL(this.file);
      } else {
        return this.file;
      }
    },
  },
  methods: {
    parseAspectRatio(ratio) {
      if (!ratio) return 1;
      const arr = ratio.split("/").map(Number);
      return arr.length === 2 && arr[1] !== 0 ? arr[0] / arr[1] : 1;
    },
    onAspectRatioChange() {
      if (!this.cropper) return;
      const aspectRatio = this.parseAspectRatio(this.aspectRatioInput);
      this.cropper.setAspectRatio(aspectRatio);
    },
    onImageLoad() {
      const img = this.$refs.imgRef;
      if (!img) return;
      const aspectRatio = this.parseAspectRatio(this.aspectRatio);
      this.cropper = new Cropper(img, {
        aspectRatio: aspectRatio,
        viewMode: 1,
        dragMode: "move",
        autoCropArea: 1,
        restore: false,
        guides: false,
        center: false,
        highlight: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        toggleDragModeOnDblclick: false,
        zoomOnWheel: true,
        zoomOnTouch: true,
        zoomable: true,
        movable: true,
        rotatable: true,
        scalable: true,
      });
    },
    onReset() {
      this.aspectRatioInput = this.aspectRatio || "1/1";
      this.onAspectRatioChange();
      this.cropper && this.cropper.reset();
    },
    onCancel() {
      this.$emit("cancel");
    },
    onConfirm() {
      this.cropper && this.cropper.crop();
      const canvas =
        this.cropper &&
        this.cropper.getCroppedCanvas({
          width: this.width,
          height: this.height,
        });
      if (canvas) {
        canvas.toBlob((blob) => {
          if (!blob) return;
          this.$emit("confirm", blob);
        });
      }
    },
    onRotateLeft() {
      this.cropper && this.cropper.rotate(-90);
    },
    onRotateRight() {
      this.cropper && this.cropper.rotate(90);
    },
  },
};
</script>
